import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import Header from '../components/Header';
import ProductList from '../components/ProductList';
import { mockProductData } from '../utils/mockData';
const getCategoryTitle = category => {
  switch (category) {
    case 'perfect-match':
      return 'Perfect Match Products';
    case 'potential-match':
      return 'Potential Match Products';
    case 'no-match':
      return 'Products Without Matches';
    case 'skipped':
      return 'Skipped Products';
    default:
      return 'Products';
  }
};
const ProductListingPage = () => {
  const {
    category
  } = useParams();
  const [products, setProducts] = useState(mockProductData);
  const handleSkipProduct = productId => {
    setProducts(prevProducts => prevProducts.map(product => product.id === productId ? {
      ...product,
      skipped: true,
      skippedAt: new Date().toISOString()
    } : product));
  };
  const filteredProducts = products.filter(product => {
    if (category === 'skipped') {
      return product.skipped;
    }
    if (category === 'no-match') {
      return product.matchCategory === 'no-match' && !product.skipped;
    }
    return product.matchCategory === category && !product.skipped;
  });
  return <div className="min-h-screen bg-gray-50" data-id="element-746">
      <Header data-id="element-747" />
      <ProductList products={filteredProducts} category={category} title={getCategoryTitle(category)} onSkipProduct={handleSkipProduct} data-id="element-748" />
    </div>;
};
export default ProductListingPage;